export const GET_COMMUNITIES = "v1/communities";
export const GET_COMMUNITIES_DROPDOWN = "v1/communities/dropdown";
export const GET_GL_MASTER_DATA = `v1/gl-masters`;
export const GET_COMMUNITY_CONTRACT = `v1/community-contract`;
